export const LS_EMAIL_KEY = 'sense365:last_email'
